import React from 'react';

const Send = () => {
    return (
        <svg
            width='22.89'
            height='22'
            viewBox='0 0 12 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M11.8438 6.99355C11.8442 7.16058 11.8 7.32469 11.7158 7.46891C11.6315 7.61313 11.5102 7.73222 11.3645 7.81386L1.52602 13.4394C1.38467 13.5196 1.22504 13.562 1.06254 13.5625C0.912689 13.5622 0.76509 13.526 0.632121 13.4569C0.499151 13.3877 0.384685 13.2878 0.298317 13.1653C0.21195 13.0428 0.156198 12.9015 0.135735 12.753C0.115272 12.6046 0.130694 12.4534 0.180709 12.3121L1.78325 7.62753C1.79904 7.58118 1.82895 7.54095 1.86878 7.51247C1.90861 7.48399 1.95635 7.4687 2.00532 7.46874H6.2188C6.28305 7.46888 6.34666 7.45581 6.40565 7.43034C6.46465 7.40486 6.51777 7.36753 6.56173 7.32066C6.60569 7.27379 6.63954 7.21838 6.66119 7.15787C6.68283 7.09737 6.6918 7.03306 6.68755 6.96894C6.67692 6.8484 6.62114 6.73633 6.5314 6.65517C6.44165 6.574 6.32456 6.52974 6.20356 6.53124H2.00942C1.96053 6.53133 1.91283 6.51612 1.87301 6.48776C1.83319 6.45939 1.80324 6.41928 1.78735 6.37304L0.179537 1.68554C0.116925 1.50592 0.110433 1.3115 0.160924 1.12811C0.211415 0.944714 0.316498 0.781016 0.462221 0.658754C0.607944 0.536492 0.787411 0.46145 0.976789 0.443594C1.16617 0.425737 1.3565 0.465911 1.52251 0.558781L11.3663 6.17734C11.511 6.25886 11.6316 6.3774 11.7155 6.52082C11.7994 6.66424 11.8437 6.82738 11.8438 6.99355Z'
                fill='black'
            />
        </svg>
    );
};

export default Send;
